var _rect, _rect2, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoToolstation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 100",
    width: 400,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 100,
    fill: "#065cab"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 8,
    fill: "#f5b800"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 20 L35 30 L30 35 L20 25 L15 30 L10 25 L15 20 L20 15 L25 20 L30 15 L35 20 L30 25 Z",
    fill: "#f5b800",
    stroke: "#ffffff",
    strokeWidth: 1
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 60,
    fontFamily: "Arial, sans-serif",
    fontSize: 42,
    fontWeight: "bold",
    fill: "#ffffff"
  }, "\n    TOOLSTATION\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 80,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#f5b800"
  }, "\n    TRADE ESSENTIALS\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoToolstation);
export default __webpack_public_path__ + "static/media/logo_toolstation.a94b8aa8998ab48542a2de0dc31d4f80.svg";
export { ForwardRef as ReactComponent };